import * as customerOrder from "./customerOrder";
import * as customerOrderFacadeImpl from "./customerOrderFacadeImpl";
import * as customerOrderStatementManagement from "./customerOrderStatementManagement";
import * as paymentOrder from "./paymentOrder";

export const business = {
  customerOrder,
  customerOrderFacadeImpl,
  customerOrderStatementManagement,
  paymentOrder,
};
